import img1 from '../../Assest/img1.jpg';
import img2 from '../../Assest/img2.jpg';
import img3 from '../../Assest/img3.jpg';
import img4 from '../../Assest/img4.jpg';
import img5 from '../../Assest/img5.jpg';
import img6 from '../../Assest/img6.jpg';
import img7 from '../../Assest/img7.jpg';
import img8 from '../../Assest/img8.jpg';
import img9 from '../../Assest/img9.jpg';
import img10 from '../../Assest/img10.jpg';
import img11 from '../../Assest/img11.jpg';
import img12 from '../../Assest/img12.jpg';
import img13 from '../../Assest/img13.jpg';
import img14 from '../../Assest/img14.jpg';
import img15 from '../../Assest/img15.jpg';
import img16 from '../../Assest/img16.jpg';
import img17 from '../../Assest/img17.jpg';
import img18 from '../../Assest/img18.jpg';
import img19 from '../../Assest/img19.jpg';
import img20 from '../../Assest/img20.jpg';
import img21 from '../../Assest/img21.jpg';
import img22 from '../../Assest/img22.jpg';
import img23 from '../../Assest/img23.jpg';


export const  images = [
    { src: img1, alt: 'Image 1', description: 'Luxurious Sofa 1' },
    { src: img2, alt: 'Image 2', description: 'Luxurious Sofa 2' },
    { src: img3, alt: 'Image 3', description: 'Luxurious Sofa 3' },
    { src: img4, alt: 'Image 4', description: 'Luxurious Sofa 4' },
    { src: img5, alt: 'Image 5', description: 'Luxurious Sofa 5' },
    { src: img6, alt: 'Image 6', description: 'Luxurious Sofa 6' },
    { src: img7, alt: 'Image 7', description: 'Luxurious Sofa 7' },
    { src: img8, alt: 'Image 8', description: 'Luxurious Sofa 8' },
    { src: img9, alt: 'Image 9', description: 'Luxurious Sofa 9' },
    { src: img10, alt: 'Image 10', description: 'Luxurious Sofa 10' },
    { src: img11, alt: 'Image 11', description: 'Luxurious Sofa 11' },
    { src: img12, alt: 'Image 12', description: 'Luxurious Sofa 12' },
    { src: img13, alt: 'Image 13', description: 'Luxurious Sofa 13' },
    { src: img14, alt: 'Image 14', description: 'Luxurious Sofa 14' },
    { src: img15, alt: 'Image 15', description: 'Luxurious Sofa 15' },
    { src: img16, alt: 'Image 16', description: 'Luxurious Sofa 16' },
    { src: img17, alt: 'Image 17', description: 'Luxurious Sofa 17' },
    { src: img18, alt: 'Image 18', description: 'Luxurious Sofa 18' },
    { src: img19, alt: 'Image 19', description: 'Luxurious Sofa 19' },
    { src: img20, alt: 'Image 20', description: 'Luxurious Sofa 20' },
    { src: img21, alt: 'Image 21', description: 'Luxurious Sofa 21' },
    { src: img22, alt: 'Image 22', description: 'Luxurious Sofa 22' },
    { src: img23, alt: 'Image 23', description: 'Luxurious Sofa 23' },
  ];
